import { render, staticRenderFns } from "./bencaoManage.vue?vue&type=template&id=58e6114c&scoped=true&"
import script from "./bencaoManage.vue?vue&type=script&lang=js&"
export * from "./bencaoManage.vue?vue&type=script&lang=js&"
import style0 from "./bencaoManage.vue?vue&type=style&index=0&id=58e6114c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e6114c",
  null
  
)

export default component.exports